import(/* webpackMode: "eager" */ "/home/runner/work/SOFAR/SOFAR/app/admin/login/page.jsx");
